import { render, staticRenderFns } from "./RoleTemplateForm.vue?vue&type=template&id=4707376e&scoped=true"
import script from "./RoleTemplateForm.vue?vue&type=script&lang=js"
export * from "./RoleTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./RoleTemplateForm.vue?vue&type=style&index=0&id=4707376e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4707376e",
  null
  
)

export default component.exports